import BookingEntity from 'Models/Entities/BookingEntity';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { convertBookedBookingToWizardData } from 'Util/_HumanWritten/BookingWizard/SummaryToWizardUtils';
import { cloneDeep } from 'lodash';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';

export const redirectEditTo = (
	setWizardData: (bookingWizardData: BookingWizardData) => void,
	setOldWizardData: (bookingWizardData: BookingWizardData) => void,
	booking: BookingEntity,
	// True when the booking wizard renders its mobile layout (`isMobileBookingWizard`,
	// which triggers well above phone widths). In that layout the filters sidebar is
	// hidden, so passenger counts can only be edited on the dedicated search step.
	isMobileWizardView: boolean,
	editType: string,
	alterReturn: boolean,
	navigate: NavigateFunction,
) => {
	const newWizardData = convertBookedBookingToWizardData(booking, true, alterReturn);

	setWizardData(new BookingWizardData({ ...newWizardData }));
	// We need to clone the data because the old wizard data is stored in a state variable and
	// we don't want to update the state variable when the regular wizard data is updated
	setOldWizardData(new BookingWizardData(cloneDeep(newWizardData)));

	let urlPath = '';
	switch (editType) {
		case 'vehicle': {
			urlPath = 'vehicle';
			break;
		}
		case 'add-on': {
			urlPath = 'add-ons';
			break;
		}
		case 'passenger': {
			urlPath = isMobileWizardView ? 'search' : 'tickets';
			break;
		}
		case 'passenger-details': {
			// Names, ages and contact details live on the dedicated passengers tab (used by both
			// the vehicle and passenger-only flows).
			urlPath = 'passengers';
			break;
		}
		case 'seating': {
			// The wizard's own seating step. It is gated on the booking holding a fare type or a
			// seat, which is the same thing this option is offered for, so it cannot be reached
			// while the step would be skipped.
			urlPath = 'seating';
			break;
		}
		case 'trip-time': {
			urlPath = 'tickets';
			break;
		}
		case 'route-direction': {
			// The route selector lives in FerryFilters. On desktop that's the sidebar alongside the
			// tickets tab; in the mobile layout the sidebar is hidden and FerryFilters is rendered by
			// the dedicated search step instead — same reason the passenger option splits this way.
			urlPath = isMobileWizardView ? 'search' : 'tickets';
			break;
		}
		case 'other': {
			// Booking name / additional information / dynamic fields — land on the tickets tab
			// on both web and mobile, from where the user can step through to the relevant tab.
			urlPath = 'tickets';
			break;
		}
	}
	navigate(`/booking-wizard/${urlPath}`);
};
